import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from 'components/Dialog';
import ConfirmationPopInContent from 'components/Generic/ConfirmationPopInContent';
import { notify } from 'components/Notifier';
import { createInitClosures } from 'services/apiOperations';
import { DialogWidth } from 'types';

const useStyles = makeStyles(theme => ({
  userMenuItem: {
    paddingLeft: '36px',
  },
}));

const CreateInitClosuresMenuItem: React.FC = () => {
  const classes = useStyles();

  const [openConfirmCreateInitClosures, setOpenConfirmCreateInitClosures] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        closable={false}
        renderButton={() => {}}
        isOpen={openConfirmCreateInitClosures}
        onClose={() => setOpenConfirmCreateInitClosures(false)}
        width={DialogWidth.SMALL_FORM}
        renderContent={() => (
          <ConfirmationPopInContent
            title={t('header.initClosures.confirm')}
            cancelText={t('no')}
            validationText={t('yes')}
            cancelAction={() => setOpenConfirmCreateInitClosures(false)}
            validateAction={async () => {
              setOpenConfirmCreateInitClosures(false);

              notify({
                message: t('header.initClosures.loading'),
                severity: 'info',
              });

              try {
                await createInitClosures();

                notify({
                  message: t('header.initClosures.success'),
                  severity: 'success',
                });
              } catch (e) {
                notify({
                  message: t('errorGeneric'),
                  severity: 'error',
                });
              }
            }}
          />
        )}
      />
      <MenuItem className={classes.userMenuItem} onClick={() => setOpenConfirmCreateInitClosures(true)}>
        {t('header.createInitClosures')}
      </MenuItem>
    </>
  );
};

export default CreateInitClosuresMenuItem;
